module.exports = __webpack_public_path__ + "static/img/android-qr.6e69140.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/android-qr.png
// module id = ab2u
// module chunks = 1